import {
  PURCHASE_OPERATOR_TOKEN_SUCCESS,
  PURCHASE_OPERATOR_TOKEN_FAILURE,
  PURCHASE_OPERATOR_TOKEN_STARTED,
  APPEND_OPERATOR_PURCHASE_DETAILS,
} from "./constants";
import {
  FETCH_ROUTE_START,
  GLOBAL_FETCH_START,
  GLOBAL_FETCH_SUCCESS,
  SAVE_ROUTE,
} from "appRedux/constants";
import api from "appRedux/api";
import { handleError, openNotificationWithIcon } from "appRedux/actions/Common";
import { redirectOperatorTokens } from "routes/RedirectRoutes";

export const appendOperatorPurchaseDetails = (data) => {
  return (dispatch) => {
    openNotificationWithIcon("Amount & Units added successfully", "Success");
    dispatch({
      type: APPEND_OPERATOR_PURCHASE_DETAILS,
      payload: data,
    });
  };
};

export const purchaseOperatorToken = (data) => {
  return (dispatch) => {
    dispatch({ type: PURCHASE_OPERATOR_TOKEN_STARTED });
    dispatch({ type: GLOBAL_FETCH_START });
    const url = "/transport/tokens/purchase-transport-token";
    api
      .post(url, data)
      .then(({ data }) => {
        if (data.status === true) {
          dispatch({ type: GLOBAL_FETCH_SUCCESS });
          openNotificationWithIcon("Token purchased successfully", "Congrats");
          dispatch(purchaseOperatorTokenSuccess(data));

          redirectOperatorTokens();
        } else {
          dispatch({ type: GLOBAL_FETCH_SUCCESS });
          handleError(data.message);
          dispatch(purchaseOperatorTokenFailure(data.message));
        }
      })
      .catch((error) => {
        handleError(error.message);
        dispatch(purchaseOperatorTokenFailure(error.message));
      });
  };
};

export const getRouteFromOperator = (operatorId, prev = []) => {
  return (dispatch) => {
    dispatch({ type: FETCH_ROUTE_START });
    const url = `routes/travel-route/${operatorId}/list`;
    api
      .get(url)
      .then(({ data }) => {
        if (data.status === true) {
          dispatch({
            type: SAVE_ROUTE,
            payload: { ...prev, [operatorId]: data.data },
          });
        } else {
          dispatch({
            type: SAVE_ROUTE,
            payload: { ...prev, [operatorId]: [] },
          });
          handleError(data.message);
          dispatch(purchaseOperatorTokenFailure(data.message));
        }
      })
      .catch((error) => {
        dispatch({ type: SAVE_ROUTE, payload: { ...prev, [operatorId]: [] } });
        handleError(error.message);
        dispatch(purchaseOperatorTokenFailure(error.message));
      });
  };
};

export const getRouteFromOperator_ = (operatorIds) => {
  return (dispatch) => {
    dispatch({ type: FETCH_ROUTE_START });
    let items = [];
    Promise.all(
      operatorIds.map((operatorId) => {
        const url = `routes/travel-route/${operatorId}/list`;
        api
          .get(url)
          .then(({ data }) => {
            if (data.status === true) {
              items.push({ [operatorId]: data.data });
            } else {
              items.push({ [operatorId]: {} });
            }
          })
          .catch(() => {
            items.push({ [operatorId]: {} });
          });
      })
    );
  };
};

export const purchaseOperatorTokenFailure = (error) => ({
  type: PURCHASE_OPERATOR_TOKEN_FAILURE,
  payload: {
    error,
  },
});

export const purchaseOperatorTokenSuccess = (data) => ({
  type: PURCHASE_OPERATOR_TOKEN_SUCCESS,
  payload: {
    ...data,
  },
});
